import { render } from "./index.vue?vue&type=template&id=6afd072e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6afd072e&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=6afd072e&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afd072e"]])

export default __exports__